import { DetailsPanel } from "PFApp/booking/components/details_panel";
import { ActivityPreview } from "PFApp/components/activity_preview/activity_preview";
import { Chats } from "PFApp/components/chats/chats";
import { CustomValuePreview } from "PFApp/components/custom_value_preview";
import { KPIsReviewSidepanel } from "PFApp/components/kpis_review_sidepanel/kpis_review_sidepanel";
import LeftActionPanel from "PFApp/components/left_action_panel/left_action_panel";
import { Navbar } from "PFApp/components/navbar/navbar";
import { ProfilePreview } from "PFApp/components/profile_preview";
import { GlobalProPilot } from "PFApp/components/propilot";
import { useIsSignedIn } from "PFApp/hooks";
import { useAppLayoutStore } from "PFApp/stores/app_layout_store";
import useIsChatEnabled from "PFApp/use_is_chat_enabled";
import { useLiveSessionCheck } from "PFApp/use_live_session_check";
import { admin, auto, sidebar } from "PFCore/base/page_layouts";
import { usePusher } from "PFCore/base/pusher";
import { isMsTeams } from "PFCore/helpers/ms_teams";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useProficiencyLevels } from "PFCore/hooks/queries/proficiency_levels/use_proficiency_levels";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag } from "PFCore/types";
import { ONE_MINUTE_MS } from "PFCore/utilities/time_consts";

import { useChangeLanguageForCurrentProfile } from "../use_change_language";
import { useAccountSwitched } from "./use_account_switched";
import { useChameleonProfilePayload } from "./use_chameleon_profile_payload";
import { useDataDogRumForCurrentProfile } from "./use_datadog_rum";
import { useMomentLocaleForCurrentProfile } from "./use_moment_locale";
import { usePendo } from "./use_pendo";

const SignedInAppShell = () => {
  useCurrentProfile();
  useProficiencyLevels();
  useMyAccountInfo();

  useMomentLocaleForCurrentProfile();
  useDataDogRumForCurrentProfile();
  useAccountSwitched();
  usePusher();
  useChangeLanguageForCurrentProfile();
  usePendo();
  useChameleonProfilePayload();

  const layout = useAppLayoutStore((state) => state.layout);

  const {
    data: { live_ttl_in_minutes }
  } = useCurrentAccount();

  const isFeatureEnabled = useIsFeatureEnabled();
  const isEngagementKPIFeatureEnabled = isFeatureEnabled(FeatureFlag.EngagementKPIs);
  const displaySidebar = layout === sidebar || layout === admin || layout === auto;

  const isChatEnabled = useIsChatEnabled();
  const displayChat =
    isChatEnabled && (layout === sidebar || layout === auto || layout === admin) && !isMsTeams();

  useLiveSessionCheck((live_ttl_in_minutes || 0) * ONE_MINUTE_MS);

  return (
    <>
      {displaySidebar && (
        <>
          <Navbar />
          <LeftActionPanel />
          <ActivityPreview />
          <ProfilePreview />
          <CustomValuePreview />
          {isEngagementKPIFeatureEnabled && <KPIsReviewSidepanel />}
          <DetailsPanel />
          {displayChat && <Chats />}
        </>
      )}
      <GlobalProPilot />
    </>
  );
};

export const SignedInBootstrapper = () => {
  const { isSignedIn } = useIsSignedIn();

  if (!isSignedIn) {
    return null;
  }

  return <SignedInAppShell />;
};
